import loadRecaptcha from "./load_recaptcha"

// Deliberately generous. Failing open too early is the worse error: a slow-but-working load would
// submit tokenless and the server would reject a legitimate signup. Warming on first interaction
// means this is rarely reached — a blocked host has usually already settled by the time of the
// click, so those users fail open immediately rather than waiting this out.
const TOKEN_TIMEOUT_MS = 6000

// Resolves with a v3 token, or null when reCAPTCHA is unreachable. Never rejects, so callers can
// submit either way and let the server decide whether a token was needed.
export default function recaptchaToken(sitekey) {
  const timeout = new Promise(resolve => setTimeout(() => resolve(null), TOKEN_TIMEOUT_MS))
  const token = loadRecaptcha(sitekey).then(recaptcha => recaptcha.execute(sitekey, { action: "submit" }))

  return Promise.race([token, timeout]).catch(() => null)
}
